module.exports = __webpack_public_path__ + "img/Nyromantikk_Andre_kunstformer_Sinding.6d8f23a5.jpg";